import { MainMenuIcon } from '@model-framework/menu';
import { MainMenuBox } from '@model-framework/menu/MenuBox';
import { faFillDrip } from '@fortawesome/free-solid-svg-icons';

type Props = {
  menuSize: number;
  isSelected: boolean;
  onClick(): void;
  text: string;
};

export const ColorMainMenu: React.FC<Props> = ({ menuSize, isSelected, onClick, text }: Props) => {
  return (
    <>
      <MainMenuBox menuSize={menuSize} isSelected={isSelected} onClick={onClick} text={text} />
      <MainMenuIcon icon={faFillDrip} menuSize={menuSize} />
    </>
  );
};
